// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PayloadStagingV1PayloadRetrievePayloadRetrievePayloadResponse {
    static getAttributeTypeMap() {
        return PayloadStagingV1PayloadRetrievePayloadRetrievePayloadResponse.attributeTypeMap;
    }
}
PayloadStagingV1PayloadRetrievePayloadRetrievePayloadResponse.discriminator = undefined;
PayloadStagingV1PayloadRetrievePayloadRetrievePayloadResponse.additionalProperties = false;
PayloadStagingV1PayloadRetrievePayloadRetrievePayloadResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=payloadStagingV1PayloadRetrievePayloadRetrievePayloadResponse.js.map